import { render, staticRenderFns } from "./PosErrDialog.vue?vue&type=template&id=2849f4fb&scoped=true&"
import script from "./PosErrDialog.vue?vue&type=script&lang=js&"
export * from "./PosErrDialog.vue?vue&type=script&lang=js&"
import style0 from "./PosErrDialog.vue?vue&type=style&index=0&id=2849f4fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849f4fb",
  null
  
)

export default component.exports